import {
  ClickableSubtitle,
  Contact,
  ContactSubtitle,
} from '@rumblefish/ui/Rumblefish23Theme';
import { contactFormId } from '../const';

const SubtitleComponent = () => (
  <>
    <ContactSubtitle
      variant="regular_500"
      width={{ xs: '100%', md: '55%', xl: '75%' }}>
      Ready to build a state-of-the-art Web3 product? You’ll need a trusted
      partner who knows how to do it - enter the expert bunch of Rumble Fish!
      <br />
      Let's talk about your requirements and start working on launching your
      XRPL product now!
    </ContactSubtitle>

    <ContactSubtitle variant="regular_300">
      Fill out the form or schedule an introductory call now:
      <br />
      <ClickableSubtitle
        color="blue"
        link={'https://bit.ly/rf-sylwia-meeting'}
        target="_blank"
        rel="noopener noreferrer">
        Yes, let's set up a meeting!
      </ClickableSubtitle>
    </ContactSubtitle>
  </>
);

export const ContactXRPL = () => {
  return (
    <Contact
      id={contactFormId}
      color="blue"
      title="Let’s build XRPL products together!"
      subtitleComponent={<SubtitleComponent />}
    />
  );
};
